import { h } from 'preact';

// Font Awesome Pro 5.15.4 duotone "badge-check" — the verified mark on an artist or team avatar.
// Two paths on purpose: the seal takes the badge colour and the check is painted on top of it, so
// the tick reads white wherever the badge sits. The earlier single-path glyph knocked the check out
// of the seal instead, which was fine on a flat background but let an avatar photo show through it.
export function IconCheckBadge({
  width = 16,
  height = 16,
  fill = 'currentColor',
  checkFill = '#fff',
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      height={height}
      // width/height above are presentation hints: the weakest thing in the cascade, so a store
      // theme's own svg sizing beats them. The same size as an inline style outranks the theme.
      style={{ width: `${width}px`, height: `${height}px` }}
      class="icon-check-badge"
    >
      <path
        fill={fill}
        // as with the size, the attribute alone is the weakest thing in the cascade: a theme's own
        // `path { fill }` or a `color !important` on the parent span (via currentColor) would beat
        // it, and the inline style is what wins
        style={{ fill }}
        d="M512 256a88 88 0 0 0-57.1-82.4A88 88 0 0 0 338.4 57.1a88 88 0 0 0-164.8 0A88 88 0 0 0 57.1 173.6a88 88 0 0 0 0 164.8 88 88 0 0 0 116.5 116.5 88 88 0 0 0 164.8 0 88 88 0 0 0 116.5-116.5A88 88 0 0 0 512 256zm-144.8-44.25l-131 130a11 11 0 0 1-15.55-.06l-75.72-76.33a11 11 0 0 1 .06-15.56L171 224a11 11 0 0 1 15.56.06l42.15 42.49 97.2-96.42a11 11 0 0 1 15.55.06l25.82 26a11 11 0 0 1-.08 15.56z"
      />
      <path
        fill={checkFill}
        style={{ fill: checkFill }}
        d="M367.2 211.75l-131 130a11 11 0 0 1-15.55-.06l-75.72-76.33a11 11 0 0 1 .06-15.56L171 224a11 11 0 0 1 15.56.06l42.15 42.49 97.2-96.42a11 11 0 0 1 15.55.06l25.82 26a11 11 0 0 1-.06 15.56z"
      />
    </svg>
  );
}
